import { Icon, IconProps } from "@chakra-ui/react";

/**
 * "Add to lists" glyph — three horizontal list rows stacked left, with a
 * plus glyph anchored to the bottom-right. Reads unambiguously as a list-
 * manipulation action and avoids the semantic collision with bookmark /
 * favorite buttons elsewhere on the comic / release detail surfaces.
 */
export function ListPlusIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H14.25C14.6642 4.5 15 4.83579 15 5.25C15 5.66421 14.6642 6 14.25 6H3.75C3.33579 6 3 5.66421 3 5.25ZM3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H14.25C14.6642 10.5 15 10.8358 15 11.25C15 11.6642 14.6642 12 14.25 12H3.75C3.33579 12 3 11.6642 3 11.25ZM3.75 16.5C3.33579 16.5 3 16.8358 3 17.25C3 17.6642 3.33579 18 3.75 18H9.75C10.1642 18 10.5 17.6642 10.5 17.25C10.5 16.8358 10.1642 16.5 9.75 16.5H3.75ZM18 13.5C18.4142 13.5 18.75 13.8358 18.75 14.25V16.5H21C21.4142 16.5 21.75 16.8358 21.75 17.25C21.75 17.6642 21.4142 18 21 18H18.75V20.25C18.75 20.6642 18.4142 21 18 21C17.5858 21 17.25 20.6642 17.25 20.25V18H15C14.5858 18 14.25 17.6642 14.25 17.25C14.25 16.8358 14.5858 16.5 15 16.5H17.25V14.25C17.25 13.8358 17.5858 13.5 18 13.5Z"
        fill="currentColor"
      />
    </Icon>
  );
}
